
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as TrendingIcon } from "../fontello/icons/svg/ic_trending.svg"


const Trending = ({ ...props }) => (
  <SvgIcon
    component={TrendingIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Trending
